var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRemoveCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 3,
    fill: "#CC0030"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.64358 12.626C5.46014 12.4628 5.34727 12.2346 5.32879 11.9898C5.33033 11.4688 5.75225 11.0469 6.27318 11.0454L17.646 11.0454C18.1688 11.0627 18.5786 11.5006 18.5613 12.0234C18.5456 12.4962 18.1835 12.885 17.7129 12.9341L6.27316 12.9341C6.03162 12.9157 5.80633 12.8055 5.64358 12.626Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRemoveCampaign);
export default __webpack_public_path__ + "static/media/ICON_REMOVE_CAMPAIGN.6f2aea545fd974e88f6b9e4df67b40e6.svg";
export { ForwardRef as ReactComponent };